import React from 'react'

import WidgetTable from './index'

import {
  FormattedWidgetData,
  isExportTableWidgetSettingsLoaded,
  TExportTableWidget,
  WidgetOrder
} from 'types/GlobalWidget'

interface ExportTableWidgetTableProps {
  formattedData: FormattedWidgetData
  isComparativeButIllegal: boolean
  order: WidgetOrder
  setOrder: (order: WidgetOrder) => void
  widget: TExportTableWidget
}

const ExportTableWidgetTable = (props: ExportTableWidgetTableProps) => {
  const { formattedData, isComparativeButIllegal, order, setOrder, widget } =
    props

  if (!isExportTableWidgetSettingsLoaded(widget)) return null

  // Sort handler - no UserEvents logging
  const handleSort = (id: string, index: number | null) => {
    const isAsc =
      order.id === id && order.index === index && order.dir === 'asc'

    setOrder({ id, index, dir: isAsc ? 'desc' : 'asc' })
  }

  return (
    <WidgetTable
      datasets={formattedData.datasets}
      formattedData={formattedData}
      isComparativeButIllegal={isComparativeButIllegal}
      onSort={handleSort}
      order={order}
      scaleFactor={1}
      settings={widget.settings}
      showLinks={false}
    />
  )
}

export default ExportTableWidgetTable
